import { Toggle } from '@client/components/common/inputs/Toggle';
import { Col, Row } from '@design-system/components/grid/grid';
import { PropsWithChildren, forwardRef } from 'react';
import { Desc, Hint } from './FormTypography';
import * as styles from './ToggleRow.css';
import { TypedOmit } from '@client/new/helpers/types';

type Props = PropsWithChildren<
  {
    title: string;
    subTitle?: string;
    value: boolean;
    onChange: (v: React.ChangeEvent<HTMLInputElement>) => void;
  } & TypedOmit<
    React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >,
    'value'
  >
>;

export const ToggleRow = forwardRef<HTMLDivElement, Props>(
  ({ title, subTitle, value, onChange, children, name }, _ref) => (
    <Col className={styles.col}>
      <Row
        className={styles.toggleRow}
        onClick={() => {
          const event = {
            target: { name, value: !value },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
          } as any;
          onChange(event);
        }}
      >
        <Desc>{title}</Desc>
        <Toggle value={value} />
      </Row>
      {subTitle && <Hint>{subTitle}</Hint>}
      {children && <div>{children}</div>}
    </Col>
  ),
);
